import {UserId} from '@legit-health/ui';
import {useTranslation} from 'react-i18next';
import {useSuspensePatient} from '@/practitioner/hooks/patient/usePatient';
import {FullScreenModalTitle} from '@/shared/components/ui/Modal';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';

export default function ModalTitle({patientId}: {patientId: UserId}) {
  const {isForClinicalTrials} = useCompany();
  const patient = useSuspensePatient(patientId);
  const {t} = useTranslation(['shared/common']);

  const title = t('shared/common:diagnosticReport.form.newCase', {
    fullname: isForClinicalTrials ? patient.name : patient.fullname
  });

  return <FullScreenModalTitle>{title}</FullScreenModalTitle>;
}
